
import store from "../store";

export function permissionMainBranch() {
  return canUser(1);
}
export function permissionMiniTCDC() {
  return canUser(2);
}
export function permissionMiniTCDCType() {
  return canUser(3);
}
export function permissionService() {
  return canUser(4);
}
export function permissionServiceArea() {
  return canUser(5);
}
export function permissionGroupVisit() {
  return canUser(6);
}
export function permissionTravelInfo() {
  return canUser(7);
}
export function permissionRestaurant() {
  return canUser(8);
}
export function permissionVenueHire() {
  return canUser(9);
}
export function permissionVenueHireDetail() {
  return canUser(10);
}
export function permissionFloor() {
  return canUser(11);
}
export function permissionMenu() {
  return canUser(12);
}
export function permissionResourceCenter() {
  return canUser(13);
}
export function permissionOnlineExhibition() {
  return canUser(14);
}
export function permissionMembership() {
  return canUser(15);
}
export function permissionMembershipRate() {
  return canUser(16);
}
export function permissionMembershipBenefit() {
  return canUser(17);
}
export function permissionMembershipMember() {
  return canUser(18);
}
export function permissionDesignWorldCalendar() {
  return canUser(19);
}
export function permissionAbout() {
  return canUser(20);
}
export function permissionNetwork() {
  return canUser(21);
}
export function permissionNews() {
  return canUser(22);
}
export function permissionPartner() {
  return canUser(23);
}
export function permissionSponserProgram() {
  return canUser(24);
}
export function permissionLocation() {
  return canUser(25);
}
export function permissionContact() {
  return canUser(26);
}
export function permissionFaq() {
  return canUser(27);
}
export function permissionFaqCategory() {
  return canUser(28);
}
export function permissionBanner() {
  return canUser(29);
}
export function permissionLandingPage() {
  return canUser(30);
}
export function permissionFreePage() {
  return canUser(31);
}
export function permissionUser() {
return canUser(32);
}
export function permissionUserRole() {
  return canUser(33);
}
export function permissionSupportVenueHire() {
  return canUser(34);
}
export function permissionSupportGroupVisit() {
  return canUser(35);
}
export function permissionSupportContact() {
  return canUser(36);
}
export function permissionOurService() {
  return canUser(37);
}
export function canUser(requestedFeature) {
  // Can user do action.
  const matchedPermission = store.state.Login.rolePermission.find(
    feature => feature.feature_id === requestedFeature
  );
  return matchedPermission;
}
export const role = {
  readOnly : 1,
  readWrite : 2,
  deny : 3,
}
export default {
  role,
  permissionMainBranch,
  permissionMiniTCDC,
  permissionMiniTCDCType,
  permissionService,
  permissionServiceArea,
  permissionGroupVisit,
  permissionTravelInfo,
  permissionRestaurant,
  permissionVenueHire,
  permissionVenueHireDetail,
  permissionFloor,
  permissionMenu,
  permissionResourceCenter,
  permissionOnlineExhibition,
  permissionMembership,
  permissionMembershipRate,
  permissionMembershipBenefit,
  permissionMembershipMember,
  permissionDesignWorldCalendar,
  permissionAbout,
  permissionNetwork,
  permissionNews,
  permissionPartner,
  permissionSponserProgram,
  permissionLocation,
  permissionContact,
  permissionFaq,
  permissionFaqCategory,
  permissionBanner,
  permissionLandingPage,
  permissionFreePage,
  permissionUser,
  permissionUserRole,
  permissionSupportVenueHire,
  permissionSupportGroupVisit,
  permissionSupportContact,
  permissionOurService,
};
